import React from 'react';
import './About.css';

const About = () => {
    return (
        <div className="about-body">
            About page
            <br></br>
            <h4>ACM</h4>
            <h5 className="about-description">The Association for Computing Machinery is an international learned society for computing. It was founded in 1947 and is the 
                world's largest scientific and educational computing society. ACM is a non-profit professional membership group, claiming nearly 
                100,000 student and professional members as of 2019. ACM has fostered growth in the computing community through its more than 180 
                professional and more than 680 student chapters worldwide. Joining an ACM chapter conveys a profound interest and dedication to the 
                computing discipline. The next step is volunteering in a variety of roles and capacities that can benefit the chapter and advance 
                career opportunities as well. Founded by Richard Hamming in 1947, ACM brings together computing educators, researchers, and professionals 
                to inspire dialogue, share resources, and address the field's challenges.</h5>
            <br></br>
            ACM IOIT
            <h5 className="about-description">ACM IOIT Student Chapter was founded on 2019, with a vision to carry forward ACM’s international intentions on a root level at 
                AISSMS’ Institute of Information Technology. The motive behind starting this Student Chapter was to instil an intrigue and passion 
                for learning and innovation in technology, among students. Our Chapter focuses on enhancing and boosting every student’s technical 
                fervour by frequently organizing various events throughout the year like Technical Workshops, Competitions, Eminent Speaker Programs, 
                and Discussions with the chapter members. We are striving to be an efficient platform for students at an undergraduate level for learning 
                new skills and putting those skills to good use.</h5>
            <br></br>
            More about our college
            <h5 className="about-description">Located at the heart of Pune city, AISSMS IOIT was established in August 1999. The college has been a prime engineering institute 
                of the city for the past decade. With good infrastructural facilities, the institute has enhanced the teaching-learning experience 
                by providing students greater resources, contact with industries and academia, employment opportunities and internships, etc. It 
                is the mission of the college to empower the society through dynamic education</h5>
        </div>
    )
}

export default About
